let XLSX = require('xlsx')

// merge单元格合并格式
function j2e(data, filename, merge) {
    //
    let startTime = new Date().getTime();

    var ws_name = "Sheet1"; //Excel第一个sheet的名称
    var wb = XLSX.utils.book_new(), ws = XLSX.utils.aoa_to_sheet(data);
    if (merge) {
        ws['!ref'] = `A1:AI${data.length}`;
        ws['!merges'] = merge;
    }
    XLSX.utils.book_append_sheet(wb, ws, ws_name);  //将数据添加到工作薄
    XLSX.writeFile(wb, filename); //导出Excel
    //
    let totalTime = new Date().getTime() - startTime;
    // console.log('j2e totalTime:', totalTime / 1000 + 's');

}


module.exports = { j2e };